import { useEffect } from "react";
import { toast } from "sonner";

/**
 * GoldieDropToast
 * --------------------------------------------------------------------------
 * Fires a one-time-per-stage celebration toast the first time a user opens
 * the app on a new drop day. We gate per-stage in localStorage so a user
 * who reloads doesn't get spammed, but each day's drop announces itself.
 *
 * Wording is intentionally Five Below — playful, hyped, with a stage
 * counter so the team feels the buildup. Toast hangs around 6s (longer
 * than default) so people actually read it before it slides away.
 */

const COPY = {
  1: { title: "The lights are going out", body: "Day 1 of 6 — Goldie's coming.", emoji: "🌑" },
  2: { title: "Glitter storm incoming!", body: "Day 2 of 6 — sparkles unlocked.", emoji: "✨" },
  3: { title: "Gold rays unlocked!", body: "Day 3 of 6 — three days closer.", emoji: "☀️" },
  4: { title: "Goldie just walked in!", body: "Day 4 of 6 — wave hi at the bottom-left.", emoji: "🍑" },
  5: { title: "The Golden Ticket has dropped!", body: "Day 5 of 6 — tomorrow's the day.", emoji: "🎟️" },
  6: { title: "IT'S GOLDIE DAY!", body: "Hunt the only Golden Dumpling on Earth.", emoji: "💥" },
};

const storageKey = (stage) => `goldie-drop-seen-${stage}-2026-05`;

export default function GoldieDropToast({ stage }) {
  useEffect(() => {
    if (!stage || !COPY[stage]) return;
    const key = storageKey(stage);
    let seen = false;
    try { seen = !!localStorage.getItem(key); } catch { /* ignore */ }
    if (seen) return;
    try { localStorage.setItem(key, "1"); } catch { /* ignore */ }

    const c = COPY[stage];
    // Defer slightly so the toast doesn't slam in before the home grid
    // has finished its entrance animation.
    const t = setTimeout(() => {
      toast(`${c.emoji} ${c.title}`, {
        description: c.body,
        duration: 6000,
        className: "goldie-drop-toast",
      });
    }, 1200);
    return () => clearTimeout(t);
  }, [stage]);

  return null;
}
